import { isRenderableIframeSource } from '../iframeSource';

import styles from './IframeUnitEditor.module.css';

interface IframeUnitEditorProps {
  iframeHeight?: number;
  iframeSource?: string;
  iframeWidth?: number;
  onChange: (
    updates: Partial<{
      iframeHeight?: number;
      iframeSource?: string;
      iframeWidth?: number;
    }>,
  ) => void;
}

export function IframeUnitEditor({
  iframeHeight = 420,
  iframeSource,
  iframeWidth = 100,
  onChange,
}: IframeUnitEditorProps) {
  return (
    <div className={styles.root}>
      <label className={styles.field}>
        <span className={styles.label}>Source URL</span>
        <input
          className={styles.input}
          onChange={(event) => {
            onChange({ iframeSource: event.target.value });
          }}
          type="url"
          value={iframeSource ?? ''}
        />
      </label>

      <div className={styles.dimensionGrid}>
        <label className={styles.field}>
          <span className={styles.label}>Width</span>
          <div className={styles.dimensionInput}>
            <input
              className={styles.input}
              min={10}
              onChange={(event) => {
                onChange({ iframeWidth: Number(event.target.value) });
              }}
              type="number"
              value={iframeWidth}
            />
            <span className={styles.suffix}>%</span>
          </div>
        </label>

        <label className={styles.field}>
          <span className={styles.label}>Height</span>
          <div className={styles.dimensionInput}>
            <input
              className={styles.input}
              min={120}
              onChange={(event) => {
                onChange({ iframeHeight: Number(event.target.value) });
              }}
              type="number"
              value={iframeHeight}
            />
            <span className={styles.suffix}>px</span>
          </div>
        </label>
      </div>

      <div className={styles.preview}>
        <p className={styles.previewLabel}>Preview</p>
        <div className={styles.previewSurface}>
          {isRenderableIframeSource(iframeSource) ? (
            <iframe
              className={styles.frame}
              src={iframeSource}
              style={{
                height: `${iframeHeight}px`,
                width: `${Math.max(10, Math.min(100, iframeWidth))}%`,
              }}
              title="Iframe preview"
            />
          ) : (
            <span className={styles.placeholder}>Add an embed source to preview it.</span>
          )}
        </div>
      </div>
    </div>
  );
}
